﻿import { upOrDownOnScrollWheel } from './HelperFunctions';


export const navigationFunctions = () => {
    const header = document.querySelector<HTMLElement>('.main-site-header');
    if (!header) return;

    if (window.innerWidth >= 991) {
        closeNavOnBodyClick();
    }

    burgerMenuClickHandler(header);
    makeNavSticky(header);
    adjustNavWidth();
    openNavLevelsClickHandler();
    applyBackBtnClickHandler();
    addEscapeKeyHandler();
    openMobileNavLevelsAccessibly();
}

const burgerMenuClickHandler = (header: HTMLElement) => {
    const burgerMenu = document.querySelector('.main-site-header__burger-menu');
    const navigationLists = document.querySelectorAll<HTMLLIElement>('.hasChildren');
    if (!burgerMenu || !navigationLists.length) return;

    burgerMenu.setAttribute('aria-expanded', 'false');

    burgerMenu.addEventListener('click', () => {
        burgerMenu.setAttribute('aria-expanded',
            burgerMenu.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
        );
        header.classList.toggle('nav-open');
        document.body.classList.toggle('nav-open');

        navigationLists.forEach((list: HTMLLIElement) => {
            if (list.classList.contains('open')) {
                list.classList.remove('open');
            }
        });
    });
}

const openNavLevelsClickHandler = () => {
    const hasChildren = document?.querySelectorAll(
        ".main-site-header .hasChildren, .site-footer .hasChildren"
    );

    if (!hasChildren.length) return;

    // Map to store hover timers for each element
    const hoverTimers = new Map<Element, number>();

    hasChildren.forEach((el) => {
        const icons = el.querySelectorAll(".icon");

        if (!icons.length) return;

        icons.forEach((icon) => {
            const toggleSubmenu = (event: Event) => {
                event.stopImmediatePropagation();
                const target = event.target as HTMLElement;
                const parent = target.closest(".hasChildren");

                if (!parent) return;

                const siblings = parent.closest(".navList")?.querySelectorAll(".hasChildren");

                parent.classList.toggle("open");

                const navLevel1Links = parent.querySelectorAll<HTMLAnchorElement>(".navLevel-1 li span a");
                const buttonBack = parent.querySelector<HTMLElement>(".nav-back-btn");
                const isOpen = parent.classList.contains("open");

                navLevel1Links.forEach((link) => {
                    link.setAttribute("tabindex", isOpen ? "0" : "-1");
                });
                if (buttonBack) {
                    buttonBack.setAttribute("tabindex", isOpen ? "0" : "-1");
                }

                if (parent.hasAttribute("aria-expanded")) {
                    parent.setAttribute("aria-expanded", isOpen ? "true" : "false");
                }

                if (isOpen && buttonBack) {
                    window.requestAnimationFrame(() => {
                        buttonBack.focus();
                    });
                }

                if (!siblings) return;

                siblings?.forEach((sib) => {
                    if (sib !== parent) {
                        sib.classList.remove("open");

                        const siblingLinks = sib.querySelectorAll<HTMLAnchorElement>(".navLevel-1 li span a");
                        const buttonBackSibling = sib.querySelector<HTMLElement>(".nav-back-btn");
                        siblingLinks.forEach((link) => {
                            link.setAttribute("tabindex", "-1");
                        });
                        if (buttonBackSibling) {
                            buttonBackSibling.setAttribute("tabindex", "-1");
                        }
                        if (sib.hasAttribute("aria-expanded")) {
                            sib.setAttribute("aria-expanded", "false");
                        }
                    }
                });
            };

            icon.addEventListener("click", toggleSubmenu);

            icon.addEventListener("keydown", (event: KeyboardEvent) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggleSubmenu(event);
                }
            });
        });

        // Add hover functionality for desktop
        if (window.innerWidth >= 991) {
            // Mouse enter - open the nav level
            el.addEventListener("mouseenter", () => {
                // Clear any pending close timer
                const timer = hoverTimers.get(el);
                if (timer) {
                    clearTimeout(timer);
                    hoverTimers.delete(el);
                }

                const siblings = el.closest(".navList")?.querySelectorAll(".hasChildren");

                el.classList.add("open");

                // Close sibling nav levels
                siblings?.forEach((sib) => {
                    if (sib !== el) {
                        sib.classList.remove("open");
                    }
                });
            });

            // Mouse leave - close the nav level with delay
            el.addEventListener("mouseleave", () => {
                const timer = window.setTimeout(() => {
                    el.classList.remove("open");
                    hoverTimers.delete(el);
                }, 200); // 200ms delay to allow moving to submenu
                hoverTimers.set(el, timer);
            });
        }
    });
};

const applyBackBtnClickHandler = () => {
    const backBtns = document.querySelectorAll(".nav-back-btn");

    if (!backBtns.length) return;

    const closeSubmenu = (el: Element) => {
        const parent = el.closest(".hasChildren");
        if (!parent) return;

        parent.classList.remove("open");
        const buttonBack = parent.querySelector<HTMLElement>(".nav-back-btn");
        if (buttonBack) {
            buttonBack.setAttribute("tabindex", "-1");
        }


        // Update submenu links tabindex when closing
        const navLevel1Links = parent.querySelectorAll<HTMLAnchorElement>(".navLevel-1 li span a");
        navLevel1Links.forEach((link) => {
            link.setAttribute("tabindex", "-1");
        });

        // Update aria-expanded on the parent li element
        if (parent.hasAttribute("aria-expanded")) {
            parent.setAttribute("aria-expanded", "false");
        }
    };

    backBtns.forEach((el) => {
        // Remove back button from tab flow to prevent loops
        el.setAttribute("tabindex", "-1");

        el.addEventListener("click", () => closeSubmenu(el));

        el.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                closeSubmenu(el);
            }
        });
    });
};

const closeNavOnBodyClick = () => {
    window.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        const nav = document.querySelector(".navList");
        const openNavs = document.querySelectorAll(".hasChildren");

        if (target !== nav && !nav?.contains(target)) {
            openNavs.forEach((el) => {
                el.classList.remove("open");
            });
        }
    });
};

const addEscapeKeyHandler = () => {
    document.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            const openMenus = document.querySelectorAll(".main-site-header .hasChildren.open");

            if (!openMenus.length) return;

            openMenus.forEach((menu) => {
                menu.classList.remove("open");

                // Update submenu links tabindex when closing
                const navLevel1Links = menu.querySelectorAll<HTMLAnchorElement>(".navLevel-1 li span a");
                navLevel1Links.forEach((link) => {
                    link.setAttribute("tabindex", "-1");
                });

                // Update aria-expanded on the parent li element
                if (menu.hasAttribute("aria-expanded")) {
                    menu.setAttribute("aria-expanded", "false");
                }

                // Return focus to the expand button
                const expandButton = menu.querySelector<HTMLElement>(".icon");
                if (expandButton) {
                    expandButton.focus();
                }
            });
        }
    });
};

//Changes to the DOM

const makeNavSticky = (header: HTMLElement) => {
    upOrDownOnScrollWheel(header);
}

const adjustNavWidth = () => {
    const links = document.querySelectorAll(
        ".main-site-header .navList > .last > ul > li"
    );

    links.forEach((link) => {
        if (link.classList.contains("hasChildren")) {
            const icon = link.querySelector<HTMLSpanElement>(".icon");
            icon?.addEventListener("click", () => {
                const tile = link.querySelector("ul");
                const tileSize = tile?.getBoundingClientRect();
                const parentNav = link.parentElement?.closest("ul");

                if (!tile || !tileSize || !parentNav) return;
                const totalTileSize: number = tileSize.right + tileSize.width;
                const windowMaxWidth: number = Math.max(
                    window.innerWidth || document.documentElement.clientWidth
                );

                if (totalTileSize > windowMaxWidth) {
                    tile.style.width = "fit-content";
                    parentNav.style.left = "auto";
                    parentNav.style.right = "100%";
                }
            });
        }
    });
};

export const openMobileNavLevelsAccessibly = () => {
    const hasChildren = document?.querySelectorAll(
        ".main-site-header .hasChildren"
    );
    if (!hasChildren.length) return;

    hasChildren.forEach((el) => {
        const navLevel1Links = el.querySelectorAll<HTMLAnchorElement>(".navLevel-1 li span a");
        const isOpen = el.classList.contains("open");

        if (!navLevel1Links.length) return;

        navLevel1Links.forEach((link) => {
            link.setAttribute("tabindex", isOpen ? "0" : "-1");
        });
    });
};
